module.exports = __webpack_public_path__ + "img/Flag_of_Hong_Kong.1494d302.svg";